// The global WizardStore's step is a plain counter shared by every wizard — duplicate
// nextStep() calls (double-fired callbacks, double clicks during the slide animation) can push it
// past the steps array, which used to render an empty dialog with no way forward. Rendering always
// goes through this clamp so an out-of-bounds step degrades to the nearest real step instead.
// Applying max(0, …) last also makes an empty steps list resolve to 0.
export const clampWizardStep = (step: number, stepsLength: number): number =>
  Math.max(0, Math.min(step, stepsLength - 1));
